module.exports = __webpack_public_path__ + "static/media/118.7fa6450f.mp3";